import {Component} from "../../../gvf/js/component";
import {UtilsService} from "../../js/utils-service";
import {GvfService} from "../../../gvf/js/gvf-service";
import Sortable from "sortablejs";

export class DropzoneComponent extends Component{
    loadFiles(dzObject,files){
        if(!$.isArray(files)){
            files = [];
        }
        for(let i = 0; i<files.length; i++){
            const file = files[i];
            file.accepted = true;
            dzObject.files.push(file);
            dzObject.emit("addedfile",file);
            dzObject.createThumbnailFromUrl(file,file.url,null,"anonymous");
            dzObject.emit("complete",file);
        }
    }

    ready(){
        this.$root.addClass("dropzone");
        const isReadonly = this.$root.hasClass("is-readonly");
        const isSingleFile = this.$root.hasClass("is-single-file");
        const isSortable = this.$root.hasClass("is-sortable");
        const $input = $("#"+this.$root.data("input"));
        const config = this.$root.data("config") || {};
        const fileTypeId = this.$root.data("filetypeid");

        if(isReadonly){
            config.dictDefaultMessage = "";
        }
        config.url = "/files/upload/";
        if(fileTypeId){
            config.url += fileTypeId+"/";
        }
        config.addRemoveLinks = !isReadonly;
        let classRef = this;
        config.init = function(){
            this.on(
                "success",
                (ev,response)=>{
                    if(response.files && response.files.length>0){
                        if(isSingleFile){
                            $input.val(response.files[0]);
                        }else{
                            let files = [];
                            if($input.val()){
                                files = JSON.parse($input.val());
                            }
                            files = files.concat(response.files);
                            $input.val(JSON.stringify(files));
                        }
                        if(response.files.length==1){
                            ev.id = response.files[0];
                        }
                        classRef.$root.trigger("dropzone:change");
                    }
                }
            );
            this.on(
                "addedfile",
                (file)=>{
                    file.previewElement.addEventListener("click",(ev)=>{
                        if(ev.target.nodeName=="SPAN" && ev.target.attributes["data-dz-name"] && !isReadonly){
                            swal({
                                title: "Cambiar nombre",
                                type: "input",
                                showCancelButton: true,
                                closeOnConfirm: true,
                                cancelButtonText: "Cancelar",
                                inputPlaceholder: "Nombre del archivo",
                                inputValue: file.name
                            },(inputValue)=>{
                                if(inputValue===false){
                                    return false;
                                }
                                if(inputValue===""){
                                    swal.showInputError("El nombre no puede estar vacío");
                                    return false;
                                }
                                GvfService.endpoint(
                                    "/cp/rep-file/change-file-name",
                                    {fileId: file.id,name: inputValue}
                                ).then(
                                    (resp)=>{
                                        $(file.previewElement).find("[data-dz-name]").html(inputValue);
                                        file.name = inputValue;
                                    }
                                ).catch(UtilsService.alertEndpointResponse);
                            });
                        }else{
                            if(file.detailUrl){
                                if(file.detailUrl.indexOf("?d=1")== -1){
                                    window.open(file.detailUrl);
                                }else{
                                    window.location = file.detailUrl;
                                }
                            }
                        }
                    });
                }
            );
            this.on(
                "removedfile",
                (ev)=>{
                    if(ev.id){
                        if(isSingleFile){
                            if($input.val()==ev.id){
                                $input.val("");
                            }
                        }else{
                            let files = [];
                            if($input.val()){
                                files = JSON.parse($input.val());
                            }
                            let i = files.indexOf(ev.id);
                            if(i== -1){
                                i = files.indexOf(parseInt(ev.id));
                            }
                            if(i>=0){
                                files.splice(i,1);
                            }
                            $input.val(JSON.stringify(files));
                        }
                        classRef.$root.trigger("dropzone:change");
                    }
                }
            );
            const files = classRef.$root.data("files");
            classRef.loadFiles(this,files);
            const dz = this;
            classRef.$root.data("dropzone",dz);
            if(isSortable && !isReadonly){
                new Sortable(
                    classRef.$root.get(0),
                    {
                        draggable: ".dz-complete",
                        onEnd: (ev)=>{
                            if($.isArray(dz.files)){
                                const value = dz.files.splice(ev.oldIndex,1)[0];
                                dz.files.splice(ev.newIndex,0,value);
                                const ids = [];
                                for(let i in dz.files){
                                    if(dz.files[i].id){
                                        ids.push(dz.files[i].id);
                                    }
                                }
                                $input.val(JSON.stringify(ids));
                                classRef.$root.trigger("dropzone:change");
                            }
                        }
                    }
                );
            }
        };
        if(this.$root.data("dropzone")){ //prevent double initialization
            this.$root.data("dropzone",null);
            const el = this.$root.get(0);
            if(el){
                el.dropzone = null;
                if(el.removeEventHandler){
                    el.removeEventHandler("click");
                }
            }
        }
        this.$root.dropzone(config);
        if(isReadonly){
            this.$root.css("pointer-events","none").find(".dz-preview").css("pointer-events","auto");
        }
    }
}

const scope = ".js-dropzone";
jQuery.fn.extend(
    {
        "dropzoneSetValue": function(value){
            if(this.is(scope)){
                const dz = this.data("dropzone");
                if(dz){
                    if(!value){
                        dz.removeAllFiles();
                        this.data("files",[]);
                    }else{
                        GvfService.endpoint(
                            "/web/rep-upload-file/get-files-info",
                            {fileIds:value}
                        ).then(
                            (resp)=>{
                                this.component().loadFiles(dz,resp.files);
                            }
                        );
                    }
                }
            }
        }
    }
);